export default __webpack_public_path__ + "static/media/facebook-outline.d9b3ecc1.svg";